import {
  Action,
  Box,
  Item,
  RadioSelect,
  Text,
  useDropdown,
} from '@revolut-internal/ui-kit'
import { FC, useRef } from 'react'

import { useProcessDebugDetailsContext } from 'pages/AiProcessDebugV2/hooks/useProcessDebugDetailsContext'

export const DebugDetailsHeader: FC = () => {
  const {
    selectedProcess,
    selectedProcessLabel,
    setSelectedProcess,
    debugProcessOptions,
  } = useProcessDebugDetailsContext()

  const processDropdownRef = useRef<HTMLDivElement | null>(null)
  const dropdown = useDropdown()

  return (
    <Box bg="widget-background">
      <Item px={0} pt={0}>
        <Item.Title color="grey-50">AI Process</Item.Title>
        {debugProcessOptions.length < 2 ? (
          <Item.Side>
            <Text color="grey-50">
              {selectedProcess ? selectedProcessLabel : 'No process selected'}
            </Text>
          </Item.Side>
        ) : (
          <>
            <Item.Side ref={processDropdownRef}>
              <Action
                {...dropdown.getAnchorProps()}
                aria-haspopup="listbox"
                aria-expanded={dropdown.state}
                useEndIcon="16/ChevronDown"
              >
                {selectedProcess ? selectedProcessLabel : 'Select a process'}
              </Action>
            </Item.Side>
            <RadioSelect
              {...dropdown.getTargetProps()}
              options={debugProcessOptions}
              value={selectedProcess}
              onChange={setSelectedProcess}
              labelList="Process options"
            />
          </>
        )}
      </Item>
    </Box>
  )
}
